import * as fabric from 'office-ui-fabric-react';

export type DoorScreenDisplayType = 1 | 2;

interface IDoorScreenDisplayTypeEnum {
    Initial: DoorScreenDisplayType;
    Detailed: DoorScreenDisplayType;
    format(value: number): string | undefined;
    doorScreenDisplayTypesArray(): fabric.IDropdownOption[];
}

const datasource = () => [
    { key: 1, text: 'Įprastas' },
    { key: 2, text: 'Su gydytojo duomenimis' }
];

export const doorScreenDisplayType: IDoorScreenDisplayTypeEnum = {
    Initial: 1,
    Detailed: 2,
    format(value: number) {
        const item = datasource().find(x => x.key === value);
        return item && item.text;
    },
    doorScreenDisplayTypesArray() {
        let types : fabric.IDropdownOption[] = [];
        types.push(datasource()[0])
        types.push(datasource()[1]);
        return types;
    }
};
